import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../config/constants";
import { getAge } from "../../config/functions";
// Components
import { TableHeader, HeaderSection, HeaderButton, SetBtnImg, HeaderText, NoPatientsText } from "./styles";
import Axios from "../../config/axios";
import Loader from "../loader";
import Title from "../title";
import PatientData from "../patientData";
// Assets
import IcoArrowUp from "../../assets/ico_arrow_up.svg";
import IcoArrowDown from "../../assets/ico_arrow_down.svg";

const Patients = () => {
  const [isLoadingPatients, setIsLoadingPatients] = useState(true);
  const [patients, setPatients] = useState([]);
  const [hospitalSoftwares, setHospitalSoftwares] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [invertedAlphabetFilter, setInvertedAlphabetFilter] = useState("active");
  const [currentSoftwareFilterId, setCurrentSoftwareFilterId] = useState(false);
  const [t] = useTranslation("global");
  const hospitalId = useSelector(({ clinician }) => clinician.data.HOSPITAL_ID);
  const clinicianRole = useSelector(({ clinician }) => clinician.data.ROLE);
  const clinicianUser = useSelector(({ clinician }) => clinician.data.CLINICIAN_USER);

  useEffect(() => {
    if (hospitalId !== undefined) {
      Axios("get", `${WEB_SERVICE_MIMS}/hospitals/softwares/${hospitalId}`)
        .then(({ data }) => {
          setHospitalSoftwares(data);
        })
        .catch((error) => {
          console.log("endpoint to get hospital softwares: ", error);
        });
    }
  }, [hospitalId]);

  useEffect(() => {
    if (hospitalId !== undefined) {
      const patientListURL =
        clinicianRole === "SUPERADMIN"
          ? `${WEB_SERVICE_MIMS}/patients/all-patients-list`
          : `${WEB_SERVICE_MIMS}/patients/list/${hospitalId}`;
      Axios("get", patientListURL)
        .then(({ data }) => {
          setPatients(data);
          setIsLoadingPatients(false);
        })
        .catch((error) => {
          console.log("url error: ", error);
        });
    }
  }, [hospitalId, clinicianRole, clinicianUser]);

  const renderPatients = () => {
    if (Boolean(patients.length)) {
      return patients.map((patient, i) => {
        const age = getAge(patient.BIRTH_DATE);
        return (
          <PatientData
            key={i}
            patientIndex={i}
            patientId={patient.PATIENT_ID}
            isThereSomePrescription={patient.isThereSomePrescription}
            isTherePrescriptionsAfter7Days={patient.isTherePrescriptionsAfter7Days}
            adherence={patient.ADHERENCE}
            user={patient.PATIENT_USER}
            gender={patient.GENDER}
            age={age}
            software={patient.SOFTWARE_ID}
            hospitalSoftwares={hospitalSoftwares}
            currentSoftwareFilterId={currentSoftwareFilterId}
          />
        );
      });
    }
  };

  const userFilter = (e) => {
    e.preventDefault();
    setCurrentSoftwareFilterId(false);
    if (invertedAlphabetFilter === "") {
      setInvertedAlphabetFilter("active");
    } else {
      invertedAlphabetFilter === "active" ? setInvertedAlphabetFilter("inactive") : setInvertedAlphabetFilter("active");
      setPatients(patients.reverse());
    }
  };

  const getApplicationsTitlePadding = () => {
    if (hospitalSoftwares.length === 5) return "55px";
    if (hospitalSoftwares.length === 4) return "105px";
    if (hospitalSoftwares.length === 3) return "155px";
  };

  return (
    <>
      <Title title={t("home.listTitle")} marginBottom="15px" />
      {isLoadingPatients ? (
        <Loader />
      ) : (
        <>
          {patients.length > 0 ? (
            <>
              <TableHeader>
                <HeaderSection width="75px"></HeaderSection>
                <HeaderSection width="135px">
                  <HeaderButton onClick={userFilter}>
                    {t("home.userFilter")}
                    {invertedAlphabetFilter !== "" && (
                      <SetBtnImg src={invertedAlphabetFilter === "active" ? IcoArrowDown : IcoArrowUp} alt="ico-arrow" />
                    )}
                  </HeaderButton>
                </HeaderSection>
                <HeaderSection width="90px">
                  <HeaderText>{t("home.patientProfile")}</HeaderText>
                </HeaderSection>
                <HeaderSection width="255px">
                  <HeaderText>{t("home.patientInformation")}</HeaderText>
                </HeaderSection>
                <HeaderSection width="300px" paddingLeft={getApplicationsTitlePadding()} justifyRight={hospitalSoftwares.length < 3}>
                  <HeaderText>{t("home.applicationsFilter")}</HeaderText>
                </HeaderSection>
              </TableHeader>
              {renderPatients()}
            </>
          ) : (
            <NoPatientsText>{t("home.registeredPatients")}</NoPatientsText>
          )}
        </>
      )}
    </>
  );
};

export default Patients;
